import React from "react";
import { transformVar } from "@quarkly/atomize";
import { createGlobalStyle } from "styled-components";

const pageStyles = {
    "404": {},
    "index": {},
    "about": {},
    "editorial-board": {},
    "instructions-for-authors": {},
    "journal-submission": {},
    "journal-management": {},
    "contact": {},
	"landingPage": {},
	"loginPage": {},
	"homePage": {},
	"registerPage": {},
	"forgetPasswordPage": {}
};

const PageStyles = createGlobalStyle`
    body {
        ${({ styles }) =>
            Object.entries(styles || {}).map(
                ([prop, value]) => `${prop}: ${transformVar(prop, value)};`
            )}
    }
`;
export const GlobalQuarklyPageStyles = ({ pageUrl }) => <PageStyles styles={pageStyles[pageUrl]} />
